export { default } from './dialog';
export type { DialogProps } from '@mui/material/Dialog';
